import React from "react";
import { hydrate, render } from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import { images } from "./constants/images";
import reportWebVitals from "./reportWebVitals";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import { HelmetProvider } from "react-helmet-async";
import CaseStudies from "./pages/CaseStudies";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import Contact from "./pages/Contact";
import Blogs from "./pages/Blogs";
import About from "./pages/About";
import Careers from "./pages/Careers";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermCondition from "./pages/TermConditions";
import CancellationPolicy from "./pages/CancellationPolicy";
import ScrollToTop from "./components/ScrollToTop";
import BlogDetail from "./pages/BlogDetail";
import PageNotFound from "./pages/PageNotFound";
import WebinarRegistration from "./pages/WebinarRegistration";
import AttendesWebinar from "./pages/AttendesWebinar";
import PaymentCallback from "./pages/PaymentCallback";
import LeadMagnet from "./pages/LeadMagnet";
import RegistrationSuccess from "./pages/RegistrationSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import WebinarFeedback from "./pages/WebinarFeedback";
import QuestionnaireList from "./pages/Quesationlist";
import SoftwareAudit from "./pages/SoftwareAudit";
import SoftwareAuditLeadMagnet from "./pages/SoftwareAuditLeadMagnet";
import EbookBudgetBlueprintLeadMagnet from "./pages/EbookBudgetBlueprintLeadMagnet";
import MvpPlanningGuideLeadMagnet from "./pages/EbookMVPLeadMagnet";
import ChoosingPartnerGuideLeadMagnet from "./pages/EbookChoosingPartnerGuideLeadMagnet";
import AuditProposalGuideLeadMagnet from "./pages/EbookAuditProposalGuideLeadMagnet";
import EbookTimeLineLeadMagnet from "./pages/EbookTimeLineLeadMagnet";
import EbookCodingLeadMagnet from "./pages/EbookCodingLeadMagnet";
import Unsubscriber from "./pages/Unsubscriber";
import { ModalProvider } from "./context/ModalContext";
import Portfolios from "./pages/Portfolios";
import Portfolio from "./pages/Portfolio";
import PortfolioNew from "./pages/PortfolioNew";
import ManufacturingERPLeadMagnet from "./pages/ManufacturingERPLeadMagnet";
import FiveSignsYouNeedCustomBusinessSoftware from "./pages/FiveSignsYouNeedCustomBusinessSoftware";
import CustomSoftwareROICalculator from "./pages/CustomSoftwareROICalculator";
import CustomBusinessSoftware from "./pages/services/CustomBusinessSoftware";
import WebApplicationDevelopment from "./pages/services/WebApplicationDevelopment";
import MobileAppDevelopment from "./pages/services/MobileAppDevelopment";
import SupportAndMaintenance from "./pages/services/SupportAndMaintenance";
import Services from "./pages/Services";
import CustomVsOffShelfDecisionMatrix from "./pages/CustomVsOffShelfDecisionMatrix";
import CustomSoftwareSuccessMetricsTracker from "./pages/CustomSoftwareSuccessMetricsTracker";
import CustomSoftwareTotalCostCalculator from "./pages/CustomSoftwareTotalCostCalculator";

import HueHoppersPaymentRedirect from "./pages/HueHoppersPaymentRedirect";

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppHead />
        <ScrollToTop />
        <ModalProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="ourworks" element={<Portfolios />} />
              <Route path="ourworks/:slug" element={<Portfolio />} />
              <Route path="ourworks-n/:name" element={<PortfolioNew />} />
              <Route path="case_studies" element={<CaseStudies />} />
              {/* <Route path="case_studies/:id" element={<CaseStudyDetail />} /> */}
              <Route path="case_studies/:slug" element={<CaseStudyDetail />} />
              <Route path="contact" element={<Contact />} />
              <Route path="blogs" element={<Blogs />} />
              <Route path="blogs/:slug" element={<BlogDetail />} />
              <Route
                path="privacy-policy-previous"
                element={<PrivacyPolicy />}
              />
              <Route
                path="term-and-conditions-previous"
                element={<TermCondition />}
              />
              <Route path="services" element={<Services />} />
              <Route
                path="cancellation-policy-previous"
                element={<CancellationPolicy />}
              />
              <Route path="carrers" element={<Careers />} />
              <Route path="lm/:slug" element={<SoftwareAuditLeadMagnet />} />
              <Route
                path="lm/five-signs-you-need-custom-business-software"
                element={<FiveSignsYouNeedCustomBusinessSoftware />}
              />
              <Route
                path="lm/the-smart-founders-budget-blueprint"
                element={<EbookBudgetBlueprintLeadMagnet />}
              />
              <Route
                path="lm/the-smart-founders-mvp-planning-guide"
                element={<MvpPlanningGuideLeadMagnet />}
              />
              <Route
                path="lm/how-to-audit-your-agencys-proposal-before-signing"
                element={<AuditProposalGuideLeadMagnet />}
              />
              <Route
                path="lm/how-an-audit-keeps-your-timeline-on-track"
                element={<EbookTimeLineLeadMagnet />}
              />
              <Route
                path="lm/how-a-software-audit-gives-you-full-control-before-coding-starts"
                element={<EbookCodingLeadMagnet />}
              />
              <Route
                path="lm/the-smart-founders-guide-to-choosing-the-right-software-partner-avoid-costly-mistakes"
                element={<ChoosingPartnerGuideLeadMagnet />}
              />
              <Route
                path="lm/manufacturing-erp"
                element={<ManufacturingERPLeadMagnet />}
              />
              <Route
                path="services/custom-business-software"
                element={<CustomBusinessSoftware />}
              />
              <Route
                path="services/web-application-development"
                element={<WebApplicationDevelopment />}
              />
              <Route
                path="services/mobile-application-development"
                element={<MobileAppDevelopment />}
              />
              <Route
                path="services/support-and-maintenance"
                element={<SupportAndMaintenance />}
              />
              <Route path="lm/:slug" element={<LeadMagnet />} />
              <Route
                path="lm/custom-software-roi-calculator"
                element={<CustomSoftwareROICalculator />}
              />
              <Route
                path="workshops/:slug/register"
                element={<WebinarRegistration />}
              />
              <Route
                path="submit-webinar-feedback/:id"
                element={<WebinarFeedback />}
              />
              <Route
                path="/registration-success"
                element={<RegistrationSuccess />}
              />
              <Route path="/payment-failed" element={<PaymentFailed />} />
              <Route
                path="workshops/:slug/registeration/:token/attend"
                element={<AttendesWebinar />}
              />
              <Route path="/payment/callback" element={<PaymentCallback />} />
              <Route
                path="/questionnaire/:token/:id"
                element={<QuestionnaireList />}
              />
              <Route
                path="software-audit/:slug/register"
                element={<SoftwareAudit />}
              />
              <Route
                path="decision-matrix"
                element={<CustomVsOffShelfDecisionMatrix />}
              />
              <Route
                path="custom/metrics/tracker"
                element={<CustomSoftwareSuccessMetricsTracker />}
              />
              <Route
                path="custom/cost/calculator"
                element={<CustomSoftwareTotalCostCalculator />}
              />
              <Route path="unsubscribe/:token" element={<Unsubscriber />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
            <Route path="/hh-pay" element={<HueHoppersPaymentRedirect />} />;
          </Routes>
          {window.location.pathname !== "/hh-pay" ? (
            <button
              onClick={() =>
                window.open(
                  "/lm/five-signs-you-need-custom-business-software",
                  "_blank",
                )
              }
              style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                background: "#0a2458",
                color: "#fff",
                padding: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                border: "none",
                borderRadius: "15px",
                cursor: "pointer",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                zIndex: 9999,
              }}
            >
              👉 {"Get 5 Signs You Need "}
              <br />
              {"Custom Business Software"}
            </button>
          ) : null}
        </ModalProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

const AppHead = () => {
  return (
    <>
      <title>Plural Code Technologies</title>

      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <link rel="shortcut icon" href={images?.logo} type="image/x-icon" />
    </>
  );
};

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement,
  );
} else {
  render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
